/* eslint no-unused-vars: [2, { "varsIgnorePattern": "CssConstants" }] */
import CssConstants from 'style/CssConstants';

class DeviceUtils {
  /* MIN_DESKTOP_WIDTH should remain constant with our
  $screen-sm-min less variable in _bootstrap-override.scss */
  static Constants = {
    MIN_DESKTOP_WIDTH: CssConstants.SCREEN_SMALL_MIN,
  };

  static getScreenWidth() {
    /* Use clientWidth in addition to window.innerWidth to be
    compatibility with older versions of InternetExplorer */
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }

  static isDesktop() {
    return DeviceUtils.getScreenWidth() >= DeviceUtils.Constants.MIN_DESKTOP_WIDTH;
  }

  static isTablet() {
    return /Tablet|iPad/i.test(navigator.userAgent);
  }

  static isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  static isMobileDevice() {
    /* Tablets will not be included in the group
    of mobile devices that use native device functionality */
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && !this.isTablet();
  }
}

export default DeviceUtils;
